import { render, staticRenderFns } from "./VFatherProAnamANxAF.vue?vue&type=template&id=32f7127a"
import script from "./VFatherProAnamANxAF.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamANxAF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports